// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/
.thumbnail-sidebar {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 8.71px;
  width: 90px;
  box-sizing: border-box;
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 0;
  scrollbar-width: thin; /* Firefox */
  scrollbar-color: var(--scrollBarBgColor) transparent; /* Firefox: thumb / track */
}

.thumbnail-sidebar::-webkit-scrollbar {
  width: 4px;
}

.thumbnail-sidebar::-webkit-scrollbar-track {
  background: transparent;
}

.thumbnail-sidebar::-webkit-scrollbar-thumb {
  background-color: var(--scrollBarBgColor);
  border-radius: 4px;
}

.thumbnail-sidebar::-webkit-scrollbar-thumb:hover {
  background-color: var(--scrollBarBorderColor);
}

.thumbnail-sidebar .thumbnail-group {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.thumbnail-sidebar .group-label {
  font-size: 16px;
  font-weight: 600;
  color: var(--ceoTrackTitleColor);
}

.thumbnail-sidebar .thumbnail-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.thumbnail-sidebar .thumbnail {
  width: 81px;
  height: 82px;
  object-fit: cover;
  cursor: pointer;
  border-radius: 4px;
  box-sizing: border-box;
}

.thumbnail-sidebar .thumbnail.active {
  border: 2px solid var(--thumbnail-border-color);
}

.thumbnail-sidebar .horizontal-separator {
  width: 95%; /* Length of the line */
  border-top: 1px solid var(--button-disabled-color);
  opacity: 1;
}
`, "",{"version":3,"sources":["webpack://./src/views/pages/manualReviewTab/components/ImageThumbnailList/ImageThumbnailList.css"],"names":[],"mappings":"AAAA;;;CAGC;AACD;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,WAAW;EACX,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,qBAAqB,EAAE,YAAY;EACnC,oDAAoD,EAAE,2BAA2B;AACnF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,UAAU,EAAE,uBAAuB;EACnC,kDAAkD;EAClD,UAAU;AACZ","sourcesContent":["/*\nThis computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), \nis the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.\n*/\n.thumbnail-sidebar {\n  display: flex;\n  align-items: flex-start;\n  flex-direction: column;\n  gap: 8.71px;\n  width: 90px;\n  box-sizing: border-box;\n  overflow-y: auto;\n  overflow-x: hidden;\n  min-height: 0;\n  scrollbar-width: thin; /* Firefox */\n  scrollbar-color: var(--scrollBarBgColor) transparent; /* Firefox: thumb / track */\n}\n\n.thumbnail-sidebar::-webkit-scrollbar {\n  width: 4px;\n}\n\n.thumbnail-sidebar::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.thumbnail-sidebar::-webkit-scrollbar-thumb {\n  background-color: var(--scrollBarBgColor);\n  border-radius: 4px;\n}\n\n.thumbnail-sidebar::-webkit-scrollbar-thumb:hover {\n  background-color: var(--scrollBarBorderColor);\n}\n\n.thumbnail-sidebar .thumbnail-group {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.thumbnail-sidebar .group-label {\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--ceoTrackTitleColor);\n}\n\n.thumbnail-sidebar .thumbnail-list {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.thumbnail-sidebar .thumbnail {\n  width: 81px;\n  height: 82px;\n  object-fit: cover;\n  cursor: pointer;\n  border-radius: 4px;\n  box-sizing: border-box;\n}\n\n.thumbnail-sidebar .thumbnail.active {\n  border: 2px solid var(--thumbnail-border-color);\n}\n\n.thumbnail-sidebar .horizontal-separator {\n  width: 95%; /* Length of the line */\n  border-top: 1px solid var(--button-disabled-color);\n  opacity: 1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
